import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadPersona'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'UX/UI 顧客体験 OOUI ユーザーリサーチ ペルソナ カスタマージャーニーマップ'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/download/persona/'}
        title="ペルソナ設計 | 資料ダウンロード | Aitria（アイトリア）"
        description="ペルソナ設計は、サービスのターゲットとなるユーザーの思考・行動を整理するためのフレームワークです。プロダクト開発やサイト制作において重要な軸となるペルソナ設計のメソッドをぜひご覧ください。"
      />
      <Template />
    </>
  )
}

export default Download
